<button class="selectable" [ngClass]="{
       'default': type == ButtonType.Default,
       'success': type == ButtonType.Success,
       'error': type == ButtonType.Error,
       'warning': type == ButtonType.Warning,
       'flag': type == ButtonType.Flag,
       'fancy' : type != undefined && type != ButtonType.Flag,
       'selected': selected,
       'disabled': disabled,
       'en': title == 'English',
       'hu': title == 'Magyar',
       }">
  <div class="icon-container" *ngIf="icon">
    <app-svg-icon class="logo" [path]="'/assets/' + icon"></app-svg-icon>
  </div>
  <div class="body-emphasized">
    {{title}}
  </div>
  <div class="footnote-regular">
    {{text}}
  </div>
</button>
